// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3CKoF","content":"LoadingAlert_content__25v6E"};